import React from "react";

export const Image = ({ title, link, smallImage }) => {
  return (
    <div className="card-container">
      <a href={link} title={title} target="_blank" rel="noopener noreferrer">
        <div className="card">
          <div className="card-content">
            <div className="card-front">
              <img src={smallImage} className="img-responsive" alt={title} />
            </div>
            <div className="card-back">
              <img src={smallImage} className="img-responsive" alt={title} />
              <div className="card-back-overlay">
                <h4>{title}</h4>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
